import { Configuration } from './configuration.interface';

/**
 * Gets the various configurations from configuration JSON file when outside Helium
 */
export class DefaultConfiguration implements Configuration {

  getReAuthFailedAttempts(): number {
    return 3;
  }

  isLimsHosted(): boolean {
    return false;
  }
}
